import { useState } from "react";
import { Star, Send, CheckCircle, Loader2 } from "lucide-react";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function ReviewPage() {
  const params = new URLSearchParams(window.location.search);
  const name = params.get("name") || "";
  const [form, setForm] = useState({ patient_name: name, rating: 5, text: "", service: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!form.patient_name.trim() || !form.text.trim()) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/reviews`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      if (res.ok) setSubmitted(true);
    } catch {}
    finally { setLoading(false); }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#0a0f1a] flex items-center justify-center p-4" dir="rtl" style={{ fontFamily: "'Tajawal',sans-serif" }}>
        <div className="text-center max-w-md">
          <div className="w-20 h-20 bg-green-400/10 rounded-full flex items-center justify-center mx-auto mb-6"><CheckCircle className="w-10 h-10 text-green-400" /></div>
          <h1 className="text-2xl font-bold text-white mb-3">شكراً لك!</h1>
          <p className="text-gray-400">تقييمك مهم جداً لنا. شكراً لثقتك بالمركز الوطني التركي لزراعة الشعر والتجميل Vatan Hair</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0f1a] flex items-center justify-center p-4" dir="rtl" style={{ fontFamily: "'Tajawal',sans-serif" }}>
      <div className="w-full max-w-lg bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-8" data-testid="review-form">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-white">قيّم تجربتك</h1>
          <p className="text-gray-400 text-sm mt-2">المركز الوطني التركي لزراعة الشعر والتجميل</p>
        </div>

        <div className="space-y-5">
          <div>
            <label className="text-sm text-gray-400 block mb-1">اسمك</label>
            <input value={form.patient_name} onChange={e => setForm(p => ({ ...p, patient_name: e.target.value }))} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white text-sm focus:border-amber-400 focus:outline-none" data-testid="review-name" />
          </div>

          <div>
            <label className="text-sm text-gray-400 block mb-2">تقييمك</label>
            <div className="flex gap-2 justify-center">
              {[1, 2, 3, 4, 5].map(n => (
                <button key={n} onClick={() => setForm(p => ({ ...p, rating: n }))} className="p-1 transition-transform hover:scale-125" data-testid={`star-${n}`}>
                  <Star className={`w-10 h-10 ${n <= form.rating ? "fill-amber-400 text-amber-400" : "text-gray-600"}`} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-sm text-gray-400 block mb-1">نوع الخدمة</label>
            <select value={form.service} onChange={e => setForm(p => ({ ...p, service: e.target.value }))} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white text-sm focus:border-amber-400 focus:outline-none" data-testid="review-service">
              <option value="" className="bg-gray-900">اختر الخدمة</option>
              <option value="زراعة شعر FUE" className="bg-gray-900">زراعة شعر FUE</option>
              <option value="زراعة لحية" className="bg-gray-900">زراعة لحية</option>
              <option value="زراعة حاجب" className="bg-gray-900">زراعة حاجب</option>
              <option value="بلازما PRP" className="bg-gray-900">بلازما PRP</option>
              <option value="ميزوثيرابي" className="bg-gray-900">ميزوثيرابي</option>
              <option value="نضارة بشرة" className="bg-gray-900">نضارة بشرة</option>
            </select>
          </div>

          <div>
            <label className="text-sm text-gray-400 block mb-1">رأيك بالتجربة</label>
            <textarea value={form.text} onChange={e => setForm(p => ({ ...p, text: e.target.value }))} rows={4} placeholder="احكيلنا عن تجربتك..." className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white text-sm focus:border-amber-400 focus:outline-none resize-none" data-testid="review-text" />
          </div>

          <button onClick={submit} disabled={loading || !form.patient_name.trim() || !form.text.trim()} className="w-full py-3.5 bg-amber-400 text-gray-900 font-bold rounded-xl hover:bg-amber-300 disabled:opacity-40 transition-all flex items-center justify-center gap-2 text-sm" data-testid="review-submit">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
            إرسال التقييم
          </button>
        </div>
      </div>
    </div>
  );
}
